import { Chip } from '@zeiss/beyond-online-react';
import { formatDistanceToNowStrict } from 'date-fns';
import { TFunction } from 'i18next';

import {
  GetInvitationResponse,
  InvitationStatus,
} from 'src/types/rest/managementPortalApi';

interface StatusChip {
  expiry?: {
    date: Date;
    show: boolean;
  };
  status: InvitationStatus;
  t: TFunction<['common', 'invitations']>;
}

export const getStatusChip = ({ expiry, status, t }: StatusChip) => {
  // Size 'xs' differ on the design and on the UI, so we use size 's' to match with the expectation.
  switch (status) {
    case InvitationStatus.pending:
      return (
        <Chip
          color="warning"
          icon="StatusPending"
          label={`${t('common:status.pending')}${expiry?.show ? ` (${t('invitations:expiresInX', { x: formatDistanceToNowStrict(expiry.date) })})` : ''}`}
          size="s"
        />
      );
    case InvitationStatus.accepted:
      return (
        <Chip
          color="success"
          icon="StatusCompleted"
          label={t('common:status.accepted')}
          size="s"
        />
      );
    case InvitationStatus.expired:
      return (
        <Chip
          color="error"
          icon="StatusSubmissionFailed"
          label={t('common:status.expired')}
          size="s"
        />
      );
    default:
      return status;
  }
};

export const isInvitationActive = (status: InvitationStatus) => {
  switch (status) {
    case InvitationStatus.pending:
      return true;
    default:
      return false;
  }
};

export const getInvitationDetailPath = ({
  applicationId,
  code,
  tenantId,
}: Pick<GetInvitationResponse, 'applicationId' | 'code' | 'tenantId'>) => {
  const params = new URLSearchParams(
    applicationId ? { applicationId } : { tenantId: tenantId ?? '' },
  );

  return `${code}?${params.toString()}`;
};
